<template>
  <div>
    <div class="header-row">
      <div>
        <h2>附件管理</h2>
        <p>按管理员配置订单和附件的物理删除时长，单位为天。</p>
      </div>
      <el-button type="primary" @click="saveSettings">保存配置</el-button>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="admin_name" label="管理员" min-width="160" />
        <el-table-column label="订单存储时间(天)" min-width="180">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.order_retention_days" :min="0" :precision="0" />
          </template>
        </el-table-column>
        <el-table-column label="附件存储时间(天)" min-width="180">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.attachment_retention_days" :min="0" :precision="0" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { fetchAdminRetentionSettings, updateAdminRetentionSettings } from "../api/orders";

export default {
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      const { data } = await fetchAdminRetentionSettings();
      this.items = data.items || [];
    },
    async saveSettings() {
      await updateAdminRetentionSettings({
        items: this.items.map((item) => ({
          admin_id: item.admin_id,
          order_retention_days: item.order_retention_days || 0,
          attachment_retention_days: item.attachment_retention_days || 0,
        })),
      });
      this.$message.success("保存成功");
      this.loadSettings();
    },
  },
};
</script>
